import React, { useState } from "react";
import "../../../../../App.css";
import {Alert, Button, Modal, notification, Select, Table, Tooltip} from "antd";
import {
  useCreateSinglePaymentRequest,
  useGetBatchId,
  useGetUserBankDetails,
} from "../hooks/usePayment";
// @ts-ignore
import RetailPayment from "../../../../../core/assets/files/RetailPayment.csv";
import { ErrorToast } from "../../../../componets/toast";

function dragAndDrop() {
  const dragDropArea = document.getElementById("uploadArea");
}

const PayByFileUpload = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [totalPayableSum, setTotalPayableSum] = useState<any>(0);
  const [fileName, setFileName] = useState<string>();
  const [hasValidationIssue, setHasValidationIssue] = useState<boolean>(false);
  const [viewAffectedRows, setViewAffectedRows] = useState<boolean>(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [insuficientFundModal, setInsuficientFundModal] = useState(false);
  const [accountToMakePaymentFrom, setAccountToMakePaymentFrom] = useState("");
  const [accountData, setAccountData] = useState(['']);
  const [api, contextHolder] = notification.useNotification();

  const { data, error, mutate, isLoading } = useCreateSinglePaymentRequest();
  const {
    data: bankData,
    mutate: mutateBankData,
    isLoading: isLoadingBankData,
  } = useGetUserBankDetails();
  const {
    data: batchId,
    mutate: mutateBatchId,
    isLoading: isLoadingBatchId,
  } = useGetBatchId();

  React.useEffect(() => {
    mutateBankData();
    mutateBatchId();
  }, []);

  let totalAmount = 0;




  const processingFee = 100 * Number(dataSource.length)

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [dataSource]);

    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const columns = [
      {
      title: "Issues",
      dataIndex: "hasIssues",
      key: "hasIssues",
      render: (hasIssues) => hasIssues.length > 0 ? <Tooltip title={
        <ol>
          {hasIssues.map((issue, index) => (
              <li key={index}>{issue}</li>
          ))}
        </ol>
      }>
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
      </Tooltip> : <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>,
    },
    {
      title: "Expense Type",
      dataIndex: "expenseType",
      key: "expenseType",
    },
    {
      title: "Total Payable",
      dataIndex: "totalPayable",
      key: "totalPayable",
    },
    {
      title: "Beneficiary Account",
      dataIndex: "beneficiaryAccount",
      key: "beneficiaryAccount",
    },
    {
      title: "Beneficiary Name",
      dataIndex: "beneficiaryName",
      key: "beneficiaryName",
    },
    {
      title: "Destination Bank Account Code",
      dataIndex: "destinationBankAccountCode",
      key: "destinationBankAccountCode",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Narration",
      dataIndex: "narration",
      key: "narration",
    },
  ];


  const rowClassName = (record: { hasIssues: string | any[]; }) => {
    if (record.hasIssues.length > 0) {
      return 'tableRowErrorHighlighted';
    }
    return '';
  };

    function refreshPage() {
   setFileName(undefined);
    setDataSource([]);

  }

  function checkSufficientBalance() {
    const check = Number(totalPayableSum + processingFee) > Number(accountData[4])
    console.log({check})
    return check
  }

  function removeNairaSymbol(amount) {
  return amount.replace('₦', '');
}


  function submitPayment() {
    setConfirmationModal(false);

    setAccountData(accountToMakePaymentFrom.split("-"))
    // const accountData = accountToMakePaymentFrom.split("-");
    //console.log("QQQQQQ: ", accountToMakePaymentFrom);
    console.log("QQQQQQ: ", accountData);


    const updatedArray = dataSource.map((obj) => {
      const updatedObj: any = {
        sourceAccount: accountData[0],
        destinationAccount: obj.beneficiaryAccount,
        narration: obj.narration,
        amount: removeNairaSymbol(obj.totalPayable),
        sourceName: accountData[1],
        destinationName: obj.beneficiaryName,
        sourceBankAccountCode: accountData[2],
        destinationBankAccountCode: obj.destinationBankAccountCode,
        destinationInstitutionCode: obj.destinationBankAccountCode,
        sourceInstitutionCode: accountData[2],
        paymentStatus: "NEW",

        paymentType: {
          code: "RetailVendor",
          description: "Retail Vendor Payment",
        },
        destAccountName: obj.beneficiaryBank,
        email: obj.email,
        phoneNumber: obj.phoneNumber,
      };
      return updatedObj;
    });

    mutate(
      {
        data: {
          batchId: batchId,
          narration: "values?.description",
          accountType: {
            code: accountData[2],
            value: accountData[3],
          },
          expenseType: "Personnel",
              paymentType: {
          code: "RetailVendor",
          description: "Retail Vendor Payment",
        },
          paymentInstructions: updatedArray,
        },
      },
      {
        onSuccess: (res: any) => {
          setSuccessModal(true);
        },
      }
    );
  }

  const handleSelectAccountChange = (event) => {
    setAccountToMakePaymentFrom(event.target.value);
    setAccountData(event.target.value.split("-"))
  };


  // function extractData($event: any) {
  //   const file = $event.target.files[0];
  //   if (file.type === "text/csv") {
  //     const reader = new FileReader();
  //     reader.readAsText(file);

  //     reader.onload = (event: any) => {
  //       const csvString = event.target.result;

  //       let rows = csvString.split("\n");
  //       rows = rows.filter((line) => line.trim() !== "");

  //       const headers = rows[0].trim().split(",");
  //       const data: any[] = [];

  //       for (let i = 1; i < rows.length; i++) {
  //         let values = rows[i].trim();
  //         values = values.split(",");

  //         const obj = {};
  //         for (let j = 0; j < headers.length; j++) {
  //           obj[headers[j]] = values[j];
  //           if (j === 2) {
  //             let amount = values[j].replace("₦", "");
  //             amount = Number(amount);
  //             //console.log("amount: ", totalAmount + amount);
  //             totalAmount = totalAmount + amount;
  //             setTotalPayableSum(totalAmount);
  //           }
  //         }
  //         data.push(obj);

  //         setDataSource(data);

  //         //console.log("dataSource: ", data);
  //       }
  //     };
  //   } else {
  //     ErrorToast("Invalid File type Select a CSV File");
  //   }
  // }


    function humanReadable(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
  }

  function extractData($event: any) {
    const file = $event.target.files[0];
    setFileName(file.name);
    if (file.type === "text/csv") {
      const reader = new FileReader();
      reader.readAsText(file);

      reader.onload = (event: any) => {
        const csvString = event.target.result;

        let rows = csvString.split("\n");

        rows = rows.filter((line) => line.trim() !== "");

        const headers = rows[0].trim().split(",");
        const data: any[] = [];

        for (let i = 1; i < rows.length; i++) {
          let values = rows[i].trim();
          values = values.split(",");

          const obj = {};
          let columnsWithIssues: any[] = []
          for (let j = 0; j < headers.length; j++) {
            obj[headers[j]?.trim()] = values[j]?.trim();

                if (j === 2) {
              let amount = values[j].replace("₦", "");
              amount = Number(amount);
              //console.log("amount: ", totalAmount + amount);
              totalAmount = totalAmount + amount;
              setTotalPayableSum(totalAmount);
            }

            if (values[j] === null || values[j]?.trim() === "") {
              console.log(headers[j]?.trim(),' has no value')
              columnsWithIssues.push(humanReadable(headers[j].trim()) + ' has no value');
            }
            switch (headers[j].trim()) {
              case 'beneficiaryAccount': {
                if (!/^\d{10}$/.test(values[j]?.trim())) {
                  columnsWithIssues.push(humanReadable(headers[j]?.trim()) + ' is invalid');
                }
                break;
              }
              case 'totalPayable': {
                if (!/^-?\d+(\.\d+)?$/.test(values[j].trim())) {
                  columnsWithIssues.push(humanReadable(headers[j]?.trim()) + ' is invalid');
                }
                break;
              }

              case 'email': {
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values[j]?.trim())) {
                  columnsWithIssues.push(humanReadable(headers[j]?.trim()) + ' is invalid');
                }
                break;
              }

              case 'phoneNumber': {
                if (!/^(\+\d{13}|0\d{10})$/.test(values[j]?.trim())) {
                  columnsWithIssues.push(humanReadable(headers[j]?.trim()) + ' is invalid');
                }
                break;
              }

              case 'destinationBankAccountCode': {
                if (!/^\d{1,8}$/.test(values[j]?.trim())) {
                  columnsWithIssues.push(humanReadable(headers[j]?.trim()) + ' is invalid');
                }
                break;
              }

              // case 'bankCode': {
              //   if (!/^\d{1,8}$/.test(values[j].trim())) {
              //     columnsWithIssues.push(humanReadable(headers[j].trim()) + ' is invalid');
              //   }
              //   break;
              // }


            }

            obj['hasIssues'] = columnsWithIssues;
            if (j === 2) {
              let amount = values[j].replace("₦", "");
              obj[headers[j].trim()] = Number(amount).toLocaleString("en-NG", {
                style: "currency",
                currency: "NGN",
              });
              if (columnsWithIssues.length === 0) {
                amount = Number(amount);
                console.log("amount: ", totalAmount + amount);
                totalAmount = totalAmount + amount;
                setTotalPayableSum(totalAmount);
              }
            }
          }
          data.push(obj);

          setDataSource(data);

          console.log("dataSource: ", data);

          hasValidationIssues(data)
        }
      };
    } else {
      ErrorToast("Invalid File type Select a CSV File");
    }
  }

    function hasValidationIssues(data: any[]) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].hasIssues && data[i].hasIssues.length > 0) {
        setHasValidationIssue(true)
        return true;
      }
    }
    setHasValidationIssue(false)
    return false;
  }

  function deleteInvalidRecords(): void {
    setDataSource(dataSource.filter((r: any) => r.hasIssues.length === 0))
    api.success({
      message: 'Success',
      description:
          'All records with issues has been deleted successfully',
    });
    hasValidationIssues(dataSource.filter((r: any) => r.hasIssues.length === 0))
    setViewAffectedRows(false)
  }


 
  return (
    <div className={"payByFileUpload"}>
      {dataSource.length === 0 && (
        <div className={"bulkPaymentDragAndDrop"}>
          <div>
            Upload your payment instruction to initiate retail/vendor payments
          </div>

          <a href={RetailPayment}>
            <span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 7.5H8V11H8.5M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
                  stroke="#48B460"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.875 6C8.28921 6 8.625 5.66421 8.625 5.25C8.625 4.83579 8.28921 4.5 7.875 4.5C7.46079 4.5 7.125 4.83579 7.125 5.25C7.125 5.66421 7.46079 6 7.875 6Z"
                  fill="#48B460"
                />
              </svg>
            </span>
            Click here to download sample payment instructions template
          </a>

          <label id="uploadArea" onDragOver={dragAndDrop}>
            <input
              type="file"
              accept="text/csv"
              style={{ display: "none" }}
              onChange={extractData}
            />

            <svg
              width="26"
              height="20"
              viewBox="0 0 26 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.4999 18.7482H6.8749C6.00629 18.7473 5.14779 18.5617 4.35638 18.2037C3.56498 17.8457 2.85877 17.3235 2.28463 16.6717C1.71049 16.0199 1.28156 15.2534 1.0263 14.4231C0.771045 13.5928 0.695299 12.7178 0.804093 11.856C0.912887 10.9942 1.20373 10.1655 1.65733 9.42468C2.11092 8.68391 2.71688 8.04808 3.435 7.55941C4.15312 7.07073 4.96696 6.74039 5.82251 6.5903C6.67806 6.44021 7.55575 6.47381 8.39732 6.68887M7.7499 9.99817C7.75004 8.61177 8.07961 7.24524 8.71147 6.0112C9.34332 4.77716 10.2594 3.71092 11.3841 2.90034C12.5089 2.08977 13.8101 1.55807 15.1807 1.34904C16.5512 1.14002 17.9519 1.25966 19.2671 1.69811C20.5823 2.13656 21.7746 2.88127 22.7456 3.87086C23.7165 4.86046 24.4385 6.06662 24.8519 7.38995C25.2653 8.71328 25.3583 10.1159 25.1233 11.4822C24.8883 12.8486 24.332 14.1395 23.5002 15.2487M11.9126 13.7105L15.6249 9.99813M15.6249 9.99813L19.3372 13.7105M15.6249 9.99813V18.7482"
                stroke="#48B460"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <div className={"dragDrop"}>Drag and drop your files here</div>

            <div className={"fileFormat"}>File format supported: CSV, XSL</div>

            <div className={"orText"}>or</div>

            <div className={"browseFile"}>Browse files</div>

            <div className={"size"}>Maximum size: 2Mb</div>
          </label>
        </div>
      )}

      {dataSource.length > 0 && (
        <div className={"paymentSummary"}>
          <div className={"psRow1"}>
            <div>{/*Payment Summary*/}</div>

            <div>
              <div>₦{(totalPayableSum + processingFee).toLocaleString()}</div>
              <div>Grand total payable</div>
            </div>

            <div>
              <div>
                  <div className={'psTitle'}>Payment Type</div>
                  <div className={'psValue'}>Retail/Vendor Payment</div>
              </div>

              <div>
                  <div className={'psTitle'}>Batch Number</div>
                  <div className={'psValue'}>{batchId}</div>
              </div>

              <div>
                  <div className={'psTitle'}>Transaction Count</div>
                  <div className={'psValue'}>{dataSource.length}</div>
              </div>

              <div>
                  <div className={'psTitle'}>Total Amount Payable</div>
                <div className={'psValue'}>₦{totalPayableSum.toLocaleString()}</div>
              </div>

              <div>
                  <div className={'psTitle'}>Processing Fee</div>
                  <div className={'psValue'}>₦{processingFee.toLocaleString()}</div>
              </div>
            </div>
          </div>

          <div className={"psRow2"}>
            <div>
              <div className="py-0 input-height">
                <label className="required fw-bold fs-9">
                  Select account to make payment from
                </label>
              </div>

              <div className={`form-control form-control-solid`}>
                <select
                  className={`no-outline fs-8 text-muted`}
                  placeholder="Select account to make payment from*"
                  onChange={(e: any) => handleSelectAccountChange(e)}
                >
                  <option value="">Select account to make payment from</option>
                  {bankData?.map((array: any, i: any) => {
                    console.log(bankData);
                    
                    return (
                      <option
                        value={`${array.accountNumber}-${array.bankName}-${array.institutionCode}-${array.balance}`}
                        key={i}
                      >
                        {array?.bankName} - {array?.accountNumber} - ₦{array?.balance.toLocaleString()}
                      </option>
                    );
                  })}
                </select>
              </div>

              {/*<button className={'addFilterButton'}>*/}
              {/*    <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
              {/*        <path d="M13.0011 14H16.0011V11H18.0011V14H21.0011V16H18.0011V19H16.0011V16H13.0011V14ZM11.0011 16.88C11.0411 17.18 10.9411 17.5 10.7211 17.71C10.3211 18.1 9.69111 18.1 9.30111 17.71L5.29111 13.7C5.18204 13.5934 5.09911 13.463 5.04881 13.319C4.9985 13.175 4.98217 13.0213 5.00111 12.87V7.75L0.211108 1.62C0.0487161 1.41153 -0.0245586 1.14726 0.00729554 0.88493C0.0391497 0.622602 0.173543 0.383546 0.381108 0.22C0.571108 0.08 0.781108 0 1.00111 0H15.0011C15.2211 0 15.4311 0.08 15.6211 0.22C15.8287 0.383546 15.9631 0.622602 15.9949 0.88493C16.0268 1.14726 15.9535 1.41153 15.7911 1.62L11.0011 7.75V16.88ZM3.04111 2L7.00111 7.07V12.58L9.00111 14.58V7.05L12.9611 2H3.04111Z" fill="#666666"/>*/}
              {/*    </svg>*/}

              {/*    Add Filters*/}
              {/*</button>*/}
              {/*<button className={'resetButton'}>Reset All</button>*/}

              {/*<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
              {/*    <path d="M18.0761 1.55371L22.2491 5.90371V22.4457H6.66034V22.4997H22.3023V5.95846L18.0761 1.55371Z" fill="#909090"/>*/}
              {/*    <path d="M18.0244 1.5H6.60712V22.446H22.2491V5.90475L18.0244 1.5Z" fill="#F4F4F4"/>*/}
              {/*    <path d="M6.49233 2.625H1.69983V7.74525H16.7748V2.625H6.49233Z" fill="#7A7B7C"/>*/}
              {/*    <path d="M16.8551 7.65818H1.79736V2.53418H16.8551V7.65818Z" fill="#DD2025"/>*/}
              {/*    <path d="M6.79013 3.40003H5.80988V7.00003H6.58088V5.78578L6.75113 5.79553C6.91655 5.79268 7.08043 5.76305 7.23638 5.70778C7.3731 5.66075 7.49888 5.58651 7.60613 5.48953C7.71525 5.39714 7.80129 5.28055 7.85738 5.14903C7.9326 4.9304 7.95947 4.69805 7.93613 4.46803C7.93144 4.30371 7.90263 4.14097 7.85063 3.98503C7.80328 3.87246 7.73302 3.77098 7.64431 3.68705C7.5556 3.60312 7.45039 3.53857 7.33538 3.49753C7.23593 3.46153 7.13319 3.4354 7.02863 3.41953C6.94944 3.40731 6.86949 3.40079 6.78938 3.40003M6.64763 5.12053H6.58088V4.01053H6.72563C6.78951 4.00592 6.85361 4.01573 6.9132 4.03922C6.97279 4.06272 7.02633 4.09931 7.06988 4.14628C7.16011 4.26704 7.20832 4.41403 7.20713 4.56478C7.20713 4.74928 7.20713 4.91653 7.04063 5.03428C6.92068 5.10025 6.78414 5.1307 6.64763 5.12053ZM9.40088 3.39028C9.31763 3.39028 9.23663 3.39628 9.17963 3.39853L9.00113 3.40303H8.41613V7.00303H9.10463C9.36774 7.01024 9.62971 6.96564 9.87563 6.87178C10.0736 6.79327 10.2488 6.66671 10.3856 6.50353C10.5186 6.33887 10.6141 6.14716 10.6654 5.94178C10.7243 5.70918 10.753 5.46996 10.7509 5.23003C10.7654 4.94665 10.7435 4.66257 10.6856 4.38478C10.6307 4.1803 10.5279 3.99185 10.3856 3.83503C10.274 3.7084 10.1374 3.60626 9.98438 3.53503C9.85296 3.47422 9.71472 3.42939 9.57263 3.40153C9.51612 3.39219 9.45889 3.38793 9.40163 3.38878M9.26513 6.34153H9.19013V4.04353H9.19988C9.35449 4.02574 9.51094 4.05364 9.64988 4.12378C9.75162 4.20502 9.83453 4.30738 9.89288 4.42378C9.95584 4.54628 9.99214 4.68073 9.99938 4.81828C10.0061 4.98328 9.99938 5.11828 9.99938 5.23003C10.0024 5.35876 9.99415 5.4875 9.97463 5.61478C9.95151 5.74545 9.90878 5.87188 9.84788 5.98978C9.77894 6.09939 9.68581 6.19176 9.57563 6.25978C9.48309 6.31963 9.37352 6.34755 9.26363 6.33928M13.0736 3.40303H11.2511V7.00303H12.0221V5.57503H12.9971V4.90603H12.0221V4.07203H13.0721V3.40303" fill="#464648"/>*/}
              {/*    <path d="M16.3369 15.1911C16.3369 15.1911 18.7279 14.7576 18.7279 15.5744C18.7279 16.3911 17.2466 16.0589 16.3369 15.1911ZM14.5691 15.2534C14.1892 15.3373 13.819 15.4602 13.4644 15.6201L13.7644 14.9451C14.0644 14.2701 14.3756 13.3499 14.3756 13.3499C14.7336 13.9524 15.1501 14.5181 15.6191 15.0389C15.2654 15.0916 14.9149 15.1637 14.5691 15.2549V15.2534ZM13.6226 10.3784C13.6226 9.66664 13.8529 9.47239 14.0321 9.47239C14.2114 9.47239 14.4131 9.55864 14.4199 10.1766C14.3615 10.7981 14.2313 11.4106 14.0321 12.0021C13.7592 11.5055 13.618 10.9473 13.6219 10.3806L13.6226 10.3784ZM10.1359 18.2654C9.40236 17.8266 11.6741 16.4759 12.0859 16.4324C12.0836 16.4331 10.9039 18.7244 10.1359 18.2654ZM19.4261 15.6711C19.4186 15.5961 19.3511 14.7659 17.8736 14.8011C17.2578 14.7912 16.6422 14.8346 16.0339 14.9309C15.4446 14.3372 14.9371 13.6675 14.5249 12.9396C14.7846 12.1892 14.9417 11.4071 14.9921 10.6146C14.9704 9.71464 14.7551 9.19864 14.0651 9.20614C13.3751 9.21364 13.2746 9.81739 13.3654 10.7159C13.4543 11.3197 13.6219 11.9092 13.8641 12.4694C13.8641 12.4694 13.5454 13.4616 13.1239 14.4486C12.7024 15.4356 12.4144 15.9531 12.4144 15.9531C11.6814 16.1917 10.9914 16.5462 10.3706 17.0031C9.75261 17.5784 9.50136 18.0201 9.82686 18.4619C10.1074 18.8429 11.0891 18.9291 11.9666 17.7794C12.4329 17.1855 12.8588 16.5611 13.2416 15.9104C13.2416 15.9104 14.5796 15.5436 14.9959 15.4431C15.4121 15.3426 15.9154 15.2631 15.9154 15.2631C15.9154 15.2631 17.1371 16.4924 18.3154 16.4489C19.4936 16.4054 19.4366 15.7446 19.4291 15.6726" fill="#DD2025"/>*/}
              {/*    <path d="M17.9666 1.55762V5.96237H22.1914L17.9666 1.55762Z" fill="#909090"/>*/}
              {/*    <path d="M18.0244 1.5V5.90475H22.2491L18.0244 1.5Z" fill="#F4F4F4"/>*/}
              {/*    <path d="M6.73233 3.34241H5.75208V6.94241H6.52607V5.72891L6.69708 5.73866C6.8625 5.73581 7.02638 5.70618 7.18232 5.65091C7.31904 5.60387 7.44482 5.52962 7.55207 5.43266C7.66038 5.34003 7.74563 5.22345 7.80107 5.09216C7.8763 4.87353 7.90316 4.64119 7.87983 4.41116C7.87514 4.24684 7.84633 4.0841 7.79432 3.92816C7.74698 3.81559 7.67672 3.71411 7.58801 3.63018C7.4993 3.54625 7.39409 3.48171 7.27908 3.44066C7.17917 3.40431 7.07592 3.37793 6.97083 3.36191C6.89164 3.34969 6.81169 3.34318 6.73158 3.34241M6.58982 5.06291H6.52308V3.95291H6.66858C6.73246 3.9483 6.79656 3.95811 6.85615 3.98161C6.91574 4.0051 6.96928 4.04169 7.01283 4.08866C7.10306 4.20942 7.15127 4.35641 7.15007 4.50716C7.15007 4.69166 7.15008 4.85891 6.98358 4.97666C6.86363 5.04263 6.72709 5.07234 6.59058 5.06216M9.34308 3.33266C9.25983 3.33266 9.17883 3.33866 9.12183 3.34091L8.94557 3.34541H8.36057V6.94541H9.04908C9.31219 6.95262 9.57416 6.90803 9.82008 6.81416C10.018 6.73565 10.1933 6.6091 10.3301 6.44591C10.4631 6.28125 10.5586 6.08954 10.6098 5.88416C10.6687 5.65156 10.6975 5.41235 10.6953 5.17241C10.7099 4.88903 10.6879 4.60495 10.6301 4.32716C10.5752 4.12268 10.4723 3.93423 10.3301 3.77741C10.2185 3.65078 10.0819 3.54864 9.92883 3.47741C9.79741 3.4166 9.65917 3.37178 9.51707 3.34391C9.46057 3.33458 9.40334 3.33031 9.34608 3.33116M9.20957 6.28391H9.13458V3.98591H9.14433C9.29894 3.96812 9.45539 3.99602 9.59433 4.06616C9.69607 4.14741 9.77898 4.24976 9.83733 4.36616C9.90029 4.48866 9.93659 4.62311 9.94382 4.76066C9.95057 4.92566 9.94382 5.06066 9.94382 5.17241C9.94688 5.30114 9.9386 5.42989 9.91908 5.55716C9.89596 5.68783 9.85323 5.81426 9.79233 5.93216C9.72339 6.04178 9.63026 6.13414 9.52008 6.20216C9.42754 6.26201 9.31797 6.28993 9.20808 6.28166M13.0158 3.34541H11.1933V6.94541H11.9643V5.51741H12.9393V4.84841H11.9643V4.01441H13.0143V3.34541" fill="white"/>*/}
              {/*</svg>*/}

              {/*<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
              {/*    <path fillRule="evenodd" clipRule="evenodd" d="M21.5868 3.30392H13.9893V1.51367L1.5011 3.44117V20.3364L13.9893 22.4874V19.8339H21.5868C21.8169 19.8456 22.0423 19.7656 22.2136 19.6116C22.3849 19.4576 22.4883 19.242 22.5011 19.0119V4.12517C22.4881 3.89527 22.3847 3.67985 22.2134 3.52597C22.0421 3.37209 21.8168 3.29226 21.5868 3.30392ZM21.7068 19.1484H13.9638L13.9511 17.7317H15.8163V16.0817H13.9368L13.9278 15.1067H15.8163V13.4567H13.9136L13.9046 12.4817H15.8163V10.8317H13.8986V9.85667H15.8163V8.20667H13.8986V7.23167H15.8163V5.58167H13.8986V4.08167H21.7068V19.1484Z" fill="#20744A"/>*/}
              {/*    <path d="M16.8663 5.5791H20.1086V7.2291H16.8663V5.5791ZM16.8663 8.20485H20.1086V9.85485H16.8663V8.20485ZM16.8663 10.8306H20.1086V12.4806H16.8663V10.8306ZM16.8663 13.4564H20.1086V15.1064H16.8663V13.4564ZM16.8663 16.0821H20.1086V17.7321H16.8663V16.0821Z" fill="#20744A"/>*/}
              {/*    <path fillRule="evenodd" clipRule="evenodd" d="M4.76135 8.00433L6.37085 7.91208L7.3826 10.6938L8.5781 7.79733L10.1876 7.70508L8.2331 11.6546L10.1876 15.6138L8.48585 15.4991L7.33685 12.4811L6.1871 15.3843L4.62335 15.2463L6.43985 11.7491L4.76135 8.00433Z" fill="white"/>*/}
              {/*</svg>*/}
            </div>




                <div className={"ppBreakdownRow2"}>
              <div>
                {
                  hasValidationIssue ? <div>
                    <Alert
                        message="The document currently being uploaded contains some validation errors. Please remove all records with errors or upload a new file."
                        showIcon
                        type="error"
                        action={
                          <>
                            <Button type="primary" size="small" danger onClick={() => setViewAffectedRows(true)}>
                              View affected records
                            </Button>
                            <Button size="small" onClick={() => refreshPage()}>
                              Upload a new file
                            </Button>

                            <Modal
                                open={viewAffectedRows}
                                title="List of Invalide Records"
                                width={'80%'}
                                onCancel={() => setViewAffectedRows(false)}
                                footer={[
                                  <Button key="back" onClick={() => setViewAffectedRows(false)}>
                                    Cancel
                                  </Button>,
                                  <Button key="submit" type="primary" onClick={() => deleteInvalidRecords()}>
                                    Delete these records
                                  </Button>,
                                  <Button key="submit" type="primary" onClick={() => refreshPage()}>
                                    Upload a new file
                                  </Button>

                                ]}
                            >
                              <div style={{width: '100%', overflowY: 'auto'}}>
                                <Alert
                                    message="Note"
                                    description="Deleting these records implies that you do not want these transactions to be processed. You can opt to upload a new file with the correct information instead."
                                    type="info"
                                    showIcon
                                    action={
                                      <Button type="primary" size="small" danger onClick={() => refreshPage()}>
                                        Upload a new file
                                      </Button>
                                    }
                                />
                                <Table
                                    pagination={false}
                                    dataSource={dataSource.filter((r: any) => r.hasIssues.length > 0)}
                                    columns={columns}
                                />
                              </div>
                            </Modal>

                          </>
                        }
                    />
                  </div> : ''
                }
         

                {/*<div>*/}
                {/*    <button>*/}
                {/*        <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                {/*            <path d="M13.0011 14H16.0011V11H18.0011V14H21.0011V16H18.0011V19H16.0011V16H13.0011V14ZM11.0011 16.88C11.0411 17.18 10.9411 17.5 10.7211 17.71C10.3211 18.1 9.69111 18.1 9.30111 17.71L5.29111 13.7C5.18204 13.5934 5.09911 13.463 5.04881 13.319C4.9985 13.175 4.98217 13.0213 5.00111 12.87V7.75L0.211108 1.62C0.0487161 1.41153 -0.0245586 1.14726 0.00729554 0.88493C0.0391497 0.622602 0.173543 0.383546 0.381108 0.22C0.571108 0.08 0.781108 0 1.00111 0H15.0011C15.2211 0 15.4311 0.08 15.6211 0.22C15.8287 0.383546 15.9631 0.622602 15.9949 0.88493C16.0268 1.14726 15.9535 1.41153 15.7911 1.62L11.0011 7.75V16.88ZM3.04111 2L7.00111 7.07V12.58L9.00111 14.58V7.05L12.9611 2H3.04111Z" fill="#666666"/>*/}
                {/*        </svg>*/}
                {/*        Add Filters*/}
                {/*    </button>*/}
                {/*</div>*/}

                {/*<div>*/}
                {/*    <button>Reset All</button>*/}
                {/*</div>*/}
              </div>

              <div>
                {
                  hasValidationIssue ? '' : <>
                    {
                           <div className={"submitButton"}>
              {accountToMakePaymentFrom === "" ? (
                <button disabled onClick={() => setConfirmationModal(true)}>
                  Submit
                </button>
              ) : (
                <button onClick={() => checkSufficientBalance() ? setConfirmationModal(true) : setConfirmationModal(true)}>
                  Submit
                </button>
              )}

              {/*<button onClick={() => setConfirmationModal(true)}>Submit</button>*/}
            </div>
                    }

                  </>
                }
              </div>
            </div>
          </div>

          

          <div className={"psRow3"}>
            <Table    rowSelection={rowSelection} dataSource={[...dataSource]} columns={columns}      rowClassName={rowClassName} />
          </div>
        </div>
      )} 

      <Modal
        centered
        style={{ width: "500px", maxWidth: "100%" }}
        open={confirmationModal}
        onOk={() => setConfirmationModal(false)}
        onCancel={() => setConfirmationModal(false)}
        footer={null}
      >
        <div className={"rvpConfirmationModal"}>
          <svg
            style={{ justifySelf: "center" }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.2499 13.8755C11.2499 14.2897 11.5857 14.6255 11.9999 14.6255C12.4142 14.6255 12.7499 14.2897 12.7499 13.8755H11.2499ZM11.9999 12.938V12.188C11.801 12.188 11.6103 12.267 11.4696 12.4077C11.329 12.5483 11.2499 12.7391 11.2499 12.938H11.9999ZM7.96869 9.65678C7.96869 10.071 8.30448 10.4068 8.71869 10.4068C9.1329 10.4068 9.46869 10.071 9.46869 9.65678H7.96869ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5V24C18.6274 24 24 18.6274 24 12H22.5ZM12 22.5C6.20101 22.5 1.5 17.799 1.5 12H0C0 18.6274 5.37258 24 12 24V22.5ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5V0C5.37258 0 0 5.37258 0 12H1.5ZM12 1.5C17.799 1.5 22.5 6.20101 22.5 12H24C24 5.37258 18.6274 0 12 0V1.5ZM12.6562 18.0938C12.6562 18.4562 12.3624 18.75 12 18.75V20.25C13.1909 20.25 14.1562 19.2846 14.1562 18.0938H12.6562ZM12 18.75C11.6376 18.75 11.3438 18.4562 11.3438 18.0938H9.84375C9.84375 19.2846 10.8091 20.25 12 20.25V18.75ZM11.3438 18.0938C11.3438 17.7313 11.6376 17.4375 12 17.4375V15.9375C10.8091 15.9375 9.84375 16.9029 9.84375 18.0938H11.3438ZM12 17.4375C12.3624 17.4375 12.6562 17.7313 12.6562 18.0938H14.1562C14.1562 16.9029 13.1909 15.9375 12 15.9375V17.4375ZM12.7499 13.8755V12.938H11.2499V13.8755H12.7499ZM11.9999 13.688C12.7972 13.688 13.5766 13.4516 14.2396 13.0086L13.4062 11.7614C12.99 12.0396 12.5006 12.188 11.9999 12.188L11.9999 13.688ZM14.2396 13.0086C14.9025 12.5657 15.4192 11.9361 15.7243 11.1995L14.3385 10.6254C14.1469 11.088 13.8225 11.4833 13.4062 11.7614L14.2396 13.0086ZM15.7243 11.1995C16.0294 10.4629 16.1093 9.6523 15.9537 8.87032L14.4826 9.16295C14.5802 9.65397 14.5301 10.1629 14.3385 10.6254L15.7243 11.1995ZM15.9537 8.87032C15.7982 8.08833 15.4142 7.37003 14.8505 6.80625L13.7898 7.86691C14.1438 8.22091 14.3849 8.67194 14.4826 9.16295L15.9537 8.87032ZM14.8505 6.80625C14.2867 6.24247 13.5684 5.85853 12.7864 5.70299L12.4938 7.17416C12.9848 7.27183 13.4358 7.51291 13.7898 7.86691L14.8505 6.80625ZM12.7864 5.70299C12.0044 5.54744 11.1939 5.62727 10.4572 5.93239L11.0313 7.31821C11.4938 7.12662 12.0027 7.0765 12.4938 7.17416L12.7864 5.70299ZM10.4572 5.93239C9.72063 6.2375 9.09104 6.7542 8.64808 7.41713L9.89528 8.25049C10.1734 7.83423 10.5687 7.50979 11.0313 7.31821L10.4572 5.93239ZM8.64808 7.41713C8.20512 8.08007 7.96869 8.85947 7.96869 9.65678H9.46869C9.46869 9.15614 9.61715 8.66675 9.89528 8.25049L8.64808 7.41713Z"
              fill="#61CD85"
            />
          </svg>

          {/*<div className={'rdFilterModalRow1'}>*/}
          <div className={"rvpConfirmationModalTitle"}>Confirmation</div>
          {/*</div>*/}

          <div style={{ justifySelf: "center" }}>
            Please confirm you want to proceed with this request
          </div>

          <div className={"rvpConfirmationModalActionButton"}>
            <button
              className="btn btn-outline-success px-7 py-2 h-44 w-200 rounded-1 "
              onClick={() => setConfirmationModal(false)}
            >
              <span className="indicator-label fs-base">Cancel</span>
            </button>

            <button
              onClick={() => submitPayment()}
              className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
            >
              <span className="indicator-label fs-base text-White">
                Proceed
              </span>
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        centered
        style={{ width: "500px", maxWidth: "100%" }}
        open={successModal}
        onOk={() => setSuccessModal(false)}
        onCancel={() => setSuccessModal(false)}
        footer={null}
      >
        <div className={"rvpConfirmationModal"}>
          <svg
            style={{ justifySelf: "center" }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.1562 9.1875L10.2812 15.75L6.84375 12.4688M23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12Z"
              stroke="#61CD85"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <div className={"rvpConfirmationModalTitle"}>Successful!</div>

          <div style={{ textAlign: "center" }}>
            Your payment request with batch no{" "}
            <span style={{ color: "#6366F1" }}>{batchId}</span> has been
            successfully sent to the reviewer group for action
          </div>

          <div className={"rvpConfirmationModalActionButton"}>
            <button
              className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
              onClick={() => {
                setSuccessModal(false);
                setDataSource([]);
                mutateBatchId();
              }}
            >
              <span className="indicator-label fs-base text-White">Ok</span>
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        centered
        style={{ width: "500px", maxWidth: "100%" }}
        open={insuficientFundModal}
        onOk={() => setInsuficientFundModal(false)}
        onCancel={() => setInsuficientFundModal(false)}
        footer={null}
      >
        <div className={"rvpConfirmationModal"}>
          <svg
            style={{ justifySelf: "center" }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.1562 9.1875L10.2812 15.75L6.84375 12.4688M23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12Z"
              stroke="#61CD85"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <div className={"rvpConfirmationModalTitle"}>Insufficient Fund!</div>

          <div style={{ textAlign: "center" }}>
            You do not have surficent balance in this account (
            <span style={{ color: "#6366F1" }}>{accountData[1]} - {accountData[0]}</span>) Kindly fund the account or select
            another account with sufficient found
          </div>

          <div className={"rvpConfirmationModalActionButton"}>
            <button
              className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
              onClick={() => {
                setInsuficientFundModal(false);
                mutateBatchId();
              }}
            >
              <span className="indicator-label fs-base text-White">Ok</span>
            </button>
          </div>
        </div>
      </Modal>


    </div>
  );
};

export default PayByFileUpload;
